// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons___vvQh","alertIcon":"ConfirmModal_alertIcon__1iRBw"};